<template>
    <div class="col-md-9 col-lg-10 ml-md-auto">
    {{statusAlert()}}
    <div v-if="error" class="validation py-3 px-5 my-4">
        <p class="m-0">{{ error }}</p>
    </div>
    <div class="edit-property-form mb-4">
      <b-container fluid class="p-0" v-if="propertyData">
        <div class="p-4 bg-light mb-3">
          <b-row>
            <b-col lg="2">
              <label class="font-weight-bold required">管理用物件名</label>
            </b-col>
            <b-col lg="10">
              <b-form-input v-model="propertyData.administrative_title" class="form-input" :state="validateState('administrative_title')"></b-form-input>
              <b-form-invalid-feedback :state="validateState('administrative_title')">
                <p v-if="!$v.propertyData.administrative_title.required">管理用物件名は必須です</p>
                <p v-if="!$v.propertyData.administrative_title.maxLength">100文字以下で入力してください</p>
                <p v-if="!$v.propertyData.administrative_title.minLength">管理用物件名{{$v.propertyData.administrative_title.$params.minLength.min}}文字以上入力してください</p>
              </b-form-invalid-feedback>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label>物件カテゴリ</label>
            </b-col>
            <b-col lg="4">
              <b-form-select v-model="propertyData.property_category" :options="property_type" class="form-select"></b-form-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label>賃貸ステータス</label>
            </b-col>
            <b-col lg="4">
              <b-form-select v-model="propertyData.report_status" :options="report_status" class="form-select"></b-form-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label>都道府県</label>
            </b-col>
            <b-col lg="4">
              <b-form-select v-model="propertyData.prefecture" :options="prefecture" class="form-select"></b-form-select>
            </b-col>
          </b-row>
        </div>
        <div class="accordion" role="tablist"  v-for="(propertyValues, key) in propertyData.property" :key="propertyValues.id">
          <b-card no-body>
            <b-card-header class="d-flex align-items-center justify-content-between bg-secondary text-white" role="tab">
              <h4 v-b-toggle="key" class="mb-0">
                {{key}}
                <span class="h-100 ml-3"><b-icon icon="pencil-fill" scale="1" v-show="propertyData.property_types[propertyValues.language] !== 'published' && propertyValues.property_name !== null"></b-icon></span>
              </h4>
              <div class="d-flex align-items-center">
                <label class="m-0 h-100 d-flex align-items-center px-4 label-check"><b-form-checkbox size="lg" :checked="propertyData.property_types[propertyValues.language] === 'published' ? true: false" @change="selectLanguage(key, $event)"></b-form-checkbox>公開</label>
                <button  v-b-toggle="key" block class="bg-transparent border-0 mr-0 w-auto h-100 px-4" :class="{ 'not-collapsed': toggleOpen, 'text-white': true }" @click="toggleOpen = !toggleOpen">
                  <span class="h-100 align-items-center d-flex icon"><b-icon icon="chevron-down" scale="1.5"></b-icon></span>
                </button>
              </div>
            </b-card-header>
            <b-collapse :id="key" :visible="propertyValues.language === $route.params.language" accordion="my-accordion" role="tabpanel">
              <b-card-body class="bg-light text-dark">
                <b-row>
                  <b-col lg="2">
                    <label class="m-0 required">表示物件名</label>
                  </b-col>
                  <b-col lg="10">
                    <b-form-input class="form-input" @input="statusDraft($event, key)" v-model="propertyValues.property_name"></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0 required">賃料</label>
                  </b-col>
                  <b-col lg="4">
                    <b-form-input class="form-input" v-model="propertyValues.rent" :state="!(propertyValues.property_name && !propertyValues.rent)"></b-form-input>
                    <b-form-invalid-feedback :state="!(propertyValues.property_name && !propertyValues.rent)">賃料は必須です</b-form-invalid-feedback>
                  </b-col>
                  <b-col lg="2">
                    <label class="m-0">坪賃料</label>
                  </b-col>
                  <b-col lg="4">
                    <b-form-input v-model="propertyValues.tsubo_rent" class="form-input"></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">管理費／共益費</label>
                  </b-col>
                  <b-col lg="4">
                    <b-form-input v-model="propertyValues.administrative_fee" class="form-input"></b-form-input>
                  </b-col>
                  <b-col lg="2">
                    <label class="m-0">坪管理費／共益費</label>
                  </b-col>
                  <b-col lg="4">
                    <b-form-input v-model="propertyValues.tsubo_management_fee" class="form-input"></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">敷金</label>
                  </b-col>
                  <b-col lg="4">
                    <b-form-input v-model="propertyValues.security_deposit" class="form-input"></b-form-input>
                  </b-col>
                  <b-col lg="2">
                    <label class="m-0">礼金</label>
                  </b-col>
                  <b-col lg="4">
                    <b-form-input class="form-input" v-model="propertyValues.key_money"></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">コピー</label>
                  </b-col>
                  <b-col lg="10">
                    <b-form-textarea class="form-input" v-model="propertyValues.copy" rows="6">
                    </b-form-textarea>
                  </b-col>
                </b-row>
                <!-- メイン画像 ここから -->
                <template v-if="propertyValues.properties_images === null">
                  <b-row>
                    <b-col lg="2">
                      <label class="m-0">{{ $t('main_image') }}</label>
                    </b-col>
                    <b-col lg="10">
                      <b-form-file required @change="uploadImage($event, key, 'mainImageNew')" accept=".jpg, .png, .gif" :placeholder="$t('label_choose-file')"></b-form-file>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="2">{{ $t('main_image_caption') }}</b-col>
                    <b-col lg="10">
                      <b-form-input class="form-input" v-model="imagesMain[key].label"></b-form-input>
                    </b-col>
                  </b-row>
                </template>
                <template v-else>
                  <div v-for="mainImage in propertyValues.properties_images.filter(i => i.index === String(0) && i.type === 'mainImage')" :key="mainImage.id">
                    <b-row>
                      <b-col lg="2">
                        <label class="m-0">{{ $t('main_image') }}</label>
                      </b-col>
                      <b-col lg="10">
                        <b-form-file :required="imageUrl(propertyValues.properties_images)" @change="uploadImage($event, key, 'mainImage')" accept=".jpg, .png, .gif" :placeholder="mainImage.images.url === '' ? $t('label_choose-file') : mainImage.images.url"></b-form-file>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="2">{{ $t('main_image_caption') }}</b-col>
                      <b-col>
                        <b-form-input v-model="mainImage.label" class="form-input"></b-form-input>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="10" class="ml-auto image-box">
                        <img :src="decodeURI(mainImage.images.url)" v-if="mainImage.images.url.startsWith('http')">
                      </b-col>
                    </b-row>
                  </div>
                </template>
                <!-- メイン画像 ここまで-->
                <!-- サブ画像 ここから -->
                <div v-for="(subImage, index) in subImages(propertyValues)" :key="subImage.id">
                  <b-row>
                    <b-col lg="2">
                      <label class="m-0">{{ $t('sub_image') }}{{ index + 1 }}</label>
                    </b-col>
                    <b-col lg="10" class="d-flex">
                      <b-form-file @change="uploadImageSub($event, key, 'subImage', index + 1)" accept=".jpg, .png, .gif" :placeholder="subImage.images.url"></b-form-file>
                      <span class="btn btn-danger ml-2" @click="deleteImageExists(propertyData, subImage, propertyValues.properties_images)"><b-icon icon="dash" scale="2"></b-icon></span>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="2">{{ $t('sub_image_caption') }}{{ index + 1 }}</b-col>
                    <b-col lg="10">
                      <b-form-input v-model="subImage.label" class="form-input"></b-form-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="10" class="d-flex align-items-center ml-auto my-2 image-box">
                      <img :src="decodeURI(subImage.images.url)" v-if="subImage.images.url.startsWith('http')">
                    </b-col>
                  </b-row>
                </div>
                <div v-for="(items, idx) in imagesDefault[0][key]" :key="items.id">
                  <b-row>
                    <b-col lg="2">{{ $t('sub_image') }}{{ subImages(propertyValues).length + idx + 1 }}</b-col>
                    <b-col lg="10" class="d-flex align-items-center ml-auto">
                      <b-form-file required @change="uploadImageSubNew($event, key, idx, 'subImage')" accept=".jpg, .png, .gif" :placeholder="$t('label_choose-file')"></b-form-file>
                      <span v-if="imagesDefault[0][key].length !== 1" class="btn btn-danger ml-2" @click="deleteImageDynamics(key, idx)" ><b-icon icon="dash" scale="2"></b-icon></span>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="2">{{ $t('sub_image_caption') }}{{ subImages(propertyValues).length + idx + 1 }}</b-col>
                    <b-col lg="10" class="d-flex align-items-center ml-auto">
                      <b-form-input v-model="items.label" class="form-input"></b-form-input>
                    </b-col>
                  </b-row>
                </div>
                <b-row>
                  <b-col lg="10" class="ml-auto">
                    <span class="btn btn-primary btn-block" @click="addImages(key)"><b-icon icon="plus" scale="2"></b-icon></span>
                  </b-col>
                </b-row>
                <!-- サブ画像 ここまで -->
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">住所</label>
                  </b-col>
                  <b-col lg="10">
                    <b-form-input class="form-input" v-model="propertyValues.street_address"></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">最寄り駅</label>
                  </b-col>
                  <b-col lg="10">
                    <b-form-textarea class="form-input" v-model="propertyValues.nearest_station" rows="6"></b-form-textarea>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">その他料金</label>
                  </b-col>
                  <b-col lg="10">
                    <b-form-textarea class="form-input" v-model="propertyValues.other_fee" rows="6"></b-form-textarea>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">方位</label>
                  </b-col>
                  <b-col lg="4">
                    <b-form-input class="form-input" v-model="propertyValues.bearing"></b-form-input>
                  </b-col>
                  <b-col lg="2">
                    <label class="m-0">物件種別</label>
                  </b-col>
                  <b-col lg="4">
                    <b-form-input class="form-input" v-model="propertyValues.property_type"></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">構造</label>
                  </b-col>
                  <b-col lg="4">
                    <b-form-input v-model="propertyValues.construction" class="form-input"></b-form-input>
                  </b-col>
                  <b-col lg="2">
                    <label class="m-0">階建て／階部分</label>
                  </b-col>
                  <b-col lg="4">
                    <b-form-input class="form-input" v-model="propertyValues.building_floor_portion"></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">駐車場</label>
                  </b-col>
                  <b-col lg="10">
                    <b-form-input class="form-input" v-model="propertyValues.parking_lot"></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">築年月</label>
                  </b-col>
                  <b-col lg="4">
                    <b-form-input class="form-input" v-model="propertyValues.date_of_construction"></b-form-input>
                  </b-col>
                  <b-col lg="2">
                    <label class="m-0">契約期間</label>
                  </b-col>
                  <b-col lg="4">
                    <b-form-input v-model="propertyValues.term_of_agreement" class="form-input"></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">取引形態</label>
                  </b-col>
                  <b-col lg="4">
                    <b-form-input class="form-input" v-model="propertyValues.form_of_transaction"></b-form-input>
                  </b-col>
                  <b-col lg="2">
                    <label class="m-0">業者付け</label>
                  </b-col>
                  <b-col lg="4">
                    <b-form-input class="form-input" v-model="propertyValues.vendor_assignment"></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">保証金</label>
                  </b-col>
                  <b-col lg="4">
                    <b-form-input v-model="propertyValues.guarantee_deposit" class="form-input"></b-form-input>
                  </b-col>
                  <b-col lg="2">
                    <label class="m-0">償却</label>
                  </b-col>
                  <b-col lg="4">
                    <b-form-input v-model="propertyValues.amortization" class="form-input"></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">保険</label>
                  </b-col>
                  <b-col lg="4">
                    <b-form-input v-model="propertyValues.insurance" class="form-input"></b-form-input>
                  </b-col>
                  <b-col lg="2">
                    <label class="m-0">専有面積</label>
                  </b-col>
                  <b-col lg="4">
                    <b-form-input v-model="propertyValues.occupied_area" class="form-input"></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">土地面積</label>
                  </b-col>
                  <b-col lg="4">
                    <b-form-input v-model="propertyValues.land_area" class="form-input"></b-form-input>
                  </b-col>
                  <b-col lg="2">
                    <label class="m-0">総戸数</label>
                  </b-col>
                  <b-col lg="4">
                    <b-form-input v-model="propertyValues.total_unit" class="form-input"></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">引き渡し時期</label>
                  </b-col>
                  <b-col lg="4">
                    <b-form-input v-model="propertyValues.delivery_time" class="form-input"></b-form-input>
                  </b-col>
                  <b-col lg="2">
                    <label class="m-0">現況</label>
                  </b-col>
                  <b-col lg="4">
                    <b-form-input v-model="propertyValues.current_situation" class="form-input"></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">造作譲渡</label>
                  </b-col>
                  <b-col lg="4">
                    <b-form-input v-model="propertyValues.assignment_of_fixture" class="form-input"></b-form-input>
                  </b-col>
                  <b-col lg="2">
                    <label class="m-0">用途地域</label>
                  </b-col>
                  <b-col lg="4">
                    <b-form-input v-model="propertyValues.area_of_use" class="form-input"></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">特記事項</label>
                  </b-col>
                  <b-col lg="4">
                    <b-form-input v-model="propertyValues.special_remarks" class="form-input"></b-form-input>
                  </b-col>
                  <b-col lg="2">
                    <label class="m-0">出店可能業種</label>
                  </b-col>
                  <b-col lg="4">
                    <b-form-input v-model="propertyValues.openable_industry" class="form-input"></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">内装状態</label>
                  </b-col>
                  <b-col lg="4">
                    <b-form-input v-model="propertyValues.interior_condition" class="form-input"></b-form-input>
                  </b-col>
                  <b-col lg="2">
                    <label class="m-0">接道状況</label>
                  </b-col>
                  <b-col lg="4">
                    <b-form-input v-model="propertyValues.roadside_situation" class="form-input"></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">設備</label>
                  </b-col>
                  <b-col lg="10">
                    <b-form-textarea class="form-input" v-model="propertyValues.facility" rows="6"></b-form-textarea>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">条件</label>
                  </b-col>
                  <b-col lg="10">
                    <b-form-textarea class="form-input" v-model="propertyValues.condition" rows="6"></b-form-textarea>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">備考</label>
                  </b-col>
                  <b-col lg="10">
                    <b-form-input class="form-input" v-model="propertyValues.remarks"></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">情報提供日</label>
                  </b-col>
                  <b-col lg="4">
                    <b-form-datepicker v-model="propertyValues.provided_on" placeholder="日付を選択してください"></b-form-datepicker>
                  </b-col>
                  <b-col lg="2">
                    <label class="m-0">次回更新日</label>
                  </b-col>
                  <b-col lg="4">
                    <b-form-datepicker v-model="propertyValues.next_update_on" placeholder="日付を選択してください"></b-form-datepicker>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">Googleマップの埋め込み用HTML</label>
                  </b-col>
                  <b-col lg="10">
                    <b-form-textarea type="text" class="form-input" @input="validationMap($event, key)"></b-form-textarea>
                    <small class="form-text text-muted">Googleマップの共有メニューからHTMLをコピーして貼り付けてください。Googleマップ用のURLが自動で埋まります。</small>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2">
                    <label class="m-0">Googleマップ用のURL</label>
                  </b-col>
                  <b-col lg="10">
                    <b-form-input type="text" class="form-input" v-model="propertyValues.google_map_url"></b-form-input>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </b-container>
    </div>
    <div class="d-flex justify-content-between align-items-center mb-4">
        <a href="#scroll" class="text-white text-decoration-none" v-smooth-scroll><b-button class="py-3 px-5" variant="primary" @click="updatePropertyData">保存</b-button></a>
        <b-button class="py-3 px-5" variant="danger" v-b-modal.modal-delete>削除</b-button>
    </div>
    <b-modal id="modal-delete" ref="modal-delete" class="del-member" hide-footer hide-header centered title="BootstrapVue">
        <h6 class="m-4 text-center">本当に削除してもよろしいですか？</h6>
        <div class="d-flex justify-content-center align-items-center">
        <b-button class="py-3 px-5 mr-3" variant="primary" @click="hideModal">キャンセル</b-button>
        <b-button class="py-3 px-5" variant="danger" v-b-modal.modal-delete @click="delete_property">削除</b-button>
        </div>
    </b-modal>
    </div>
</template>
<script>
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import { mapActions, mapState } from 'vuex'
import { prefectures, rentalCommercialPropertyValues } from '../../../assets/data/values'

export default {
  props: {
    apiType: {
      validator: function (value) {
        return ['member', 'admin'].indexOf(value) !== -1
      },
      default: 'admin'
    }
  },
  data () {
    return {
      toggleOpen: false,
      subImage: {
        日本語: [],
        英語: [],
        簡体字: [],
        繁体字: []
      },
      mainImage: {
        日本語: null,
        英語: null,
        簡体字: null,
        繁体字: null
      },
      imagesDefault: [{
        日本語: [{ url: '', label: '' }],
        英語: [{ url: '', label: '' }],
        簡体字: [{ url: '', label: '' }],
        繁体字: [{ url: '', label: '' }]
      }],
      imagesMain: {
        日本語: { url: '', label: '' },
        英語: { url: '', label: '' },
        簡体字: { url: '', label: '' },
        繁体字: { url: '', label: '' }
      },
      en_lang: false,
      ja_lang: false,
      tw_lang: false,
      cn_lang: false,
      status: [],
      error: null,
      property: 'a',
      imgDelete: [],
      property_type: rentalCommercialPropertyValues.propertyTypes,
      report_status: [{ value: null, text: this.$i18n.t('please_choose') }].concat(rentalCommercialPropertyValues.reportStatus.map(v => { return { value: v, text: this.$i18n.t(v) } })),
      prefecture: prefectures.map(p => { return { value: p, text: this.$i18n.t(p.charAt(0).toUpperCase() + p.slice(1)) } })
    }
  },
  validations: {
    propertyData: {
      administrative_title: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(100)
      }
    }
  },
  created () {
    this.getProperty({
      propertyId: this.$route.params.id,
      apiType: this.apiType
    })
    this.activeLanguage()
  },
  computed: {
    ...mapState('adminProperty', ['propertyData']),
    ...mapState(['apiStatus'])
  },
  methods: {
    ...mapActions('adminProperty', ['getProperty', 'deleteProperty', 'deleteImage', 'updateProperty', 'statusPageList', 'updateImageViaFile']),
    validateState (name) {
      const { $dirty, $error } = this.$v.propertyData[name]
      return $dirty ? !$error : null
    },
    validationMap ($event, key) {
      if ($event === null) {
        return
      }

      const result = $event.match(/src="([^"]+)"/)
      if (!result) {
        return
      }
      this.propertyData.property[key].google_map_url = result[1]
    },
    onSubmit (event) {
      // サーバに送信する画像情報の先頭にメイン画像情報を言語ごとに挿入する
      this.imagesDefault.forEach(element => {
        for (var key in element) {
          this.imagesDefault[0][key].unshift(this.imagesMain[key])
        }
      })
      const dataValue = { dataValue: { property: this.propertyData, imageDefault: this.imagesDefault }, mainImageFile: this.mainImage, subImageFile: this.subImage }
      this.updateProperty(dataValue)
      this.clearImages()
    },
    currencyUpdate (key, event, location) {
      this.propertyData.property[key][location] = event.target.value
    },
    uploadImage: function (event, key, status) {
      if (event.target.files.length === 0) return

      if (status !== 'mainImageNew') {
        this.mainImage[key] = event.target.files[0]
        const updateImage = this.mainImage[key].name
        let data = []
        data = { updateImage: updateImage, key: key, status: status }
        this.updateImageViaFile(data)
      } else {
        const nameImage = event.target.files[0].name
        this.mainImage[key] = event.target.files[0]
        this.imagesMain[key].url = nameImage
      }
    },
    uploadImageSub: function (event, key, status, index) {
      if (event.target.files.length === 0) return

      const nameImage = event.target.files[0].name
      this.subImage[key].push({ type: 'exist', index: index, file: event.target.files[0] })
      const updateImage = nameImage
      let data = []
      data = { updateImage: updateImage, key: key, status: status, index: index }
      this.updateImageViaFile(data)
    },
    uploadImageSubNew: function (event, key, keys, status) {
      if (event.target.files.length === 0) return

      const nameImage = event.target.files[0].name
      this.subImage[key].push({ type: 'new', index: this.subImage[key].length, file: event.target.files[0] })
      this.imagesDefault[0][key][keys].url = nameImage
    },
    updatePropertyData: function () {
      if (this.$v.$invalid) {
        this.error = 'エラー：すべてのフィールドを確認して、再試行してください'
      } else {
        this.imagesDefault.forEach(element => {
          for (var key in element) {
            this.imagesDefault[0][key].unshift(this.imagesMain[key])
          }
        })
        const values = this.propertyData.property
        const mustNotEmpty = []
        for (var key in values) {
          if (values[key].property_name !== null) {
            if (values[key].rent === null) {
              values[key].rent = ''
            }
            if (values[key].property_name.length === 0 || values[key].rent.length === 0) {
              mustNotEmpty.push(true)
            }
          }
        }
        if (mustNotEmpty.length < 1) {
          this.propertyData.deletedImages = this.imgDelete
          const dataValue = { dataValue: { property: this.propertyData, imageDefault: this.imagesDefault }, mainImageFile: this.mainImage, subImageFile: this.subImage }
          this.updateProperty({ data: dataValue, apiType: 'admin' })
          this.error = null
        } else {
          this.error = 'エラー：すべてのフィールドを確認して、再試行してください'
        }
        this.clearImages()
        this.$nextTick(() => {
          this.$v.$reset()
        })
        this.error = null
      }
    },
    activeLanguage: function () {
      switch (this.$route.params.language) {
        case 'ja':
          return (this.ja_lang = true)
        case 'en':
          return (this.en_lang = true)
        case 'tw':
          return (this.tw_lang = true)
        case 'cn':
          return (this.cn_lang = true)
      }
    },
    delete_property: function () {
      this.deleteProperty({ data: this.$route.params.id, apiType: 'admin' })
    },
    hideModal () {
      this.$refs['modal-delete'].hide()
    },
    addImages: function (key) {
      this.imagesDefault[0][key].push({ url: '', label: '' })
    },
    deleteImageExists: function (localizedProperty, image, images) {
      this.imgDelete.push(image.image_id)
      localizedProperty.deletedImages = this.imgDelete

      this.$delete(images, images.findIndex(i => i.image_id === image.image_id))
    },
    statusDraft: function (event, keys) {
      const languageTypes = this.propertyData.property_types
      switch (keys) {
        case '日本語':
          if (event.length > 0 && languageTypes.name_ja !== 'published') {
            this.status = { status: 'draft', language: 'name_ja' }
          }
          break
        case '英語':
          if (event.length > 0 && languageTypes.name_en !== 'published') {
            this.status = { status: 'draft', language: 'name_en' }
          }
          break
        case '簡体字':
          if (event.length > 0 && languageTypes['name_zh-cn'] !== 'published') {
            this.status = { status: 'draft', language: 'name_zh-cn' }
          }
          break
        case '繁体字':
          if (event.length > 0 && languageTypes['name_zh-tw'] !== 'published') {
            this.status = { status: 'draft', language: 'name_zh-tw' }
          }
          break
        default:
          break
      }
      this.statusPageList(this.status)
    },
    selectLanguage: function (keys, e) {
      switch (keys) {
        case '日本語':
          if (e === true) {
            this.status = { status: 'published', language: 'name_ja' }
          } else {
            this.status = { status: 'draft', language: 'name_ja' }
          }
          break
        case '英語':
          if (e === true) {
            this.status = { status: 'published', language: 'name_en' }
          } else {
            this.status = { status: 'draft', language: 'name_en' }
          }
          break
        case '簡体字':
          if (e === true) {
            this.status = { status: 'published', language: 'name_zh-cn' }
          } else {
            this.status = { status: 'draft', language: 'name_zh-cn' }
          }
          break
        case '繁体字':
          if (e === true) {
            this.status = { status: 'published', language: 'name_zh-tw' }
          } else {
            this.status = { status: 'draft', language: 'name_zh-tw' }
          }
          break
        default:
          break
      }
      this.statusPageList(this.status)
    },
    deleteImageDynamics: function (lang, key) {
      if (this.imagesDefault[0][lang].length > 1) {
        this.imagesDefault[0][lang].splice(key, 1)
        this.subImage[lang].splice(key, 1)
      }
    },
    statusAlert (append = false) {
      if (this.apiStatus !== null) {
        this.$bvToast.toast('body', {
          title: this.apiStatus,
          toaster: 'b-toaster-top-center',
          solid: true,
          appendToast: append,
          autoHideDelay: 3000
        })
      }
    },
    imageUrl: function (imageurl) {
      if (imageurl[0].images.url !== '') {
        return false
      } else {
        return true
      }
    },
    subImages: function (localizedProperty) {
      return (localizedProperty.properties_images !== null ? localizedProperty.properties_images : []).filter(i => i.index !== String(0))
    },
    clearImages: function () {
      this.imagesDefault = [{
        日本語: [{ url: '', label: '' }],
        英語: [{ url: '', label: '' }],
        簡体字: [{ url: '', label: '' }],
        繁体字: [{ url: '', label: '' }]
      }]
    }
  }
}
</script>
<style scoped>
.image-box img {
  width: 200px;
}
.bg-light .row,
.card-body .row {
  margin-bottom: .8rem;
  align-items: center;
}
.bg-light > .row:last-child,
.card-body > .row:last-child {
  margin-bottom: 0;
}
</style>
